/* eslint-disable no-unused-vars */
import { cloneDeep, get, sortBy } from 'lodash'
import { COUPON_AGE_TYPE, COUPON_PRICE_TYPE } from '@/constants/coupon'
import moment from 'moment'

export default {
  data() {
    return {}
  },
  methods: {
    $_couponMixin_convertStayNightDetails(stayNights, stayRoomDetails, coupons) {
      const stayNightDetails = []
      stayRoomDetails = cloneDeep(stayRoomDetails)
      
      // 日付毎にオブジェクトを生成
      for (let i = 0; i < stayNights; i++) {
        const night = {
          stayDay: stayRoomDetails[0].stayDays[i].stayDay,
          rooms: [],
          coupons: [],
          expended: false
        }

        // ROOMS
        stayRoomDetails.forEach((room) => {
          let roomInfo = cloneDeep(room)
          roomInfo = { ...roomInfo, ...room.stayDays[i] }
          night['rooms'].push(roomInfo)
        })

        const cloneCoupons = []
        coupons.forEach((c) => {
          const applicableDegreeCnt = c.availableData.applicableDegreeCnt
          const couponPriceList = JSON.parse(JSON.stringify(c.availableData.priceList))
          const minTgtAge = c.availableData.minTgtAge
          // copy coupon
          const cloneCoupon = cloneDeep(c)
          // new price list
          const clonePriceList = []
          // 企業補助金の場合は料金情報を、宿泊者の続柄によって初期化する
          // 対象は利用可能フラグが立っている補助金
          if (c.availableData.requestType === '01') {
            couponPriceList.forEach((p) => {
              // check relationship degree
              let flag = false
              // 利用可能親等数が設定されていない場合、利用可能フラグを立てる
              if (applicableDegreeCnt === null) {
                flag = true
              } else {
                // 利用可能親等数が設定されている場合は、続柄レベルで判定し、
                // 子供の場合は対象最低年齢以上であることも判定する
                stayRoomDetails.forEach((room) => {
                const relationships = room.relationships
                  relationships.forEach((rel) => {
                    if (+rel.relationship.relationshipLevel <= applicableDegreeCnt) {
                      if (p.ageType === COUPON_AGE_TYPE.CHILDREN) {
                        if (rel.isChildren && rel.age >= minTgtAge) {
                          flag = true
                        }
                      } else {
                        flag = true
                      }
                    }
                  })
                })
              }
              if(flag) {
                const clonePrice = cloneDeep(p)
                clonePrice.priceLabel = `${p.priceType} ${p.ageType}`
                clonePrice.useCnt = 0
                clonePrice.selectUseCnt = 0
                clonePriceList.push(clonePrice)
              }
            })
          } else {
            // 健保補助金の場合は、料金設定をチェックし、
            // 続柄から単価種別、年齢種別が対象範囲かを判定し、対象の範囲の続柄に適用できる料金設定がある場合に、
            // 利用可能フラグを立てて初期化する
            // 健保は「本人、妻、長男」等詳細な続柄で残枚数や選択できる枚数を判定する為、続柄情報も料金情報にセットする
            couponPriceList.forEach((p) => {
              stayRoomDetails.forEach((room) => {
                const relationships = room.relationships
                relationships.forEach((rel) => {
                  /**
                   * 各続柄の料金で利用できるかの判定を行う
                   * 判定に使用するマスタは以下の通りである
                   * 
                   * ※単価種別：priceType
                   * OWNER  :本人
                   * FAMILY :家族
                   * BOLT   :一律
                   * 
                   * ※年齢種別：ageType
                   * ADULT    :大人
                   * CHILDREN :子供
                   * BOLT     :一律
                   */
                  let price = null
                  // 本人の場合
                  if (rel.relationship.relationshipId === '0') {
                    // まず料金種別が本人で判定をする
                    if (!rel.isChildren) {
                      if (p.priceType === COUPON_PRICE_TYPE.OWNER && p.ageType === COUPON_AGE_TYPE.ADULT) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    } else {
                      if (p.priceType === COUPON_PRICE_TYPE.OWNER && p.ageType === COUPON_AGE_TYPE.CHILDREN) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    }
                    if (!price) {
                      if (p.priceType === COUPON_PRICE_TYPE.OWNER && p.ageType === COUPON_AGE_TYPE.BOLT) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    }
                  // 本人以外で、利用可能親等数が設定されていない補助金か、
                  // 続柄レベルが利用可能な範囲内である場合は、まず単価種別家族で判定する
                  } else if (
                    applicableDegreeCnt === null ||
                    +rel.relationship.relationshipLevel <= applicableDegreeCnt
                  ) {
                    if (!rel.isChildren) {
                      if (p.priceType === COUPON_PRICE_TYPE.FAMILY && p.ageType === COUPON_AGE_TYPE.ADULT) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    } else {
                      if (p.priceType === COUPON_PRICE_TYPE.FAMILY && p.ageType === COUPON_AGE_TYPE.CHILDREN) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    }
                    if (!price) {
                      if (p.priceType === COUPON_PRICE_TYPE.FAMILY && p.ageType === COUPON_AGE_TYPE.BOLT) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    }
                  }
                  if (!price) {
                    if(p.priceType === COUPON_PRICE_TYPE.BOLT)
                    {
                      if (
                        !price &&
                        !rel.isChildren &&
                        p.ageType === COUPON_AGE_TYPE.ADULT
                      ) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      } else if (
                        !price &&
                        rel.isChildren &&
                        p.ageType === COUPON_AGE_TYPE.CHILDREN
                      ) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    }
                    if (!price) {
                      if (p.priceType === COUPON_PRICE_TYPE.BOLT && p.ageType === COUPON_AGE_TYPE.BOLT) {
                        price = cloneDeep(p)
                        price.relationshipCode = rel.relationshipCode
                        price.priceLabel = rel.relationship.relationshipName
                      }
                    }
                  }
                  if (price) {
                    let found = false
                    clonePriceList.forEach((cc) => {
                      // 同じ宿泊日・部屋で、処理中の宿泊者に重複した補助金を適用しない為の制御
                      if (
                        cc.relationshipCode === price.relationshipCode &&
                        price.subsidyPriceId === cc.subsidyPriceId
                      ) {
                        found = true
                      }
                    })
                    if (!found) {
                      price.useCnt = 0
                      price.relationship = rel.relationship
                      price.selectUseCnt = 0
                      clonePriceList.push(price)
                    }
                  }
                })
              })
            })
          }
          cloneCoupon.availableData.priceList = clonePriceList
          cloneCoupons.push(cloneCoupon)
        })
        night['coupons'] = cloneCoupons
        stayNightDetails.push(night)
      }
      return stayNightDetails
    },

    /**
     * stayDay: checkin day
     * stayNights: number of night
     * coupons: coupon list
     * @return {
     *  stayNightDetails
     *  totalDiscountAmount
     *  totalForceUseDiscount
     *  totalAppliedCouponPrice
     *  remainingSubsidys
     *  options:
     *    applyType: auto, manual,
     * }
     */
    $_couponMixin_applyCoupon({
      stayDay,
      stayNights,
      coupons,
      vacancyCalendar,
      stayNightDetails,
      options = {
        applyOptional: true,
        applyType: 'auto'
      }
    }) {
      let totalDiscountAmount = 0
      let totalAppliedCouponPrice = 0
      let totalForceUseDiscount = 0
      let remainingSubsidys = cloneDeep(coupons)
      stayNightDetails = JSON.parse(JSON.stringify(stayNightDetails))
      // map price
      stayNightDetails = this.$_couponMixin_mapNightPrice({
        stayNightDetails,
        stayDay,
        stayNights,
        vacancyCalendar
      })
      // GET PEOPLE PRICE
      let relationships = []
      stayNightDetails.forEach((night) => {
        night.rooms.forEach((room) => {
          room.relationships?.forEach((r) => {
            // 「その他会員」の場合補助金適応外
            if (r.relationshipCode !== "C-205-9") {
              relationships.push(r)
            }
          })
        })
      })

      // SORT PEOPLE
      // 値段でソートしている。
      // 複数部屋の場合、値段が違うことがあり、順番が崩れる為、補助金適用後に元の並びに戻す
      relationships = relationships.sort((a, b) => {
        return b.price - a.price
      })

      /**
       * APPLY CHO TỪNG RELATIONSHIP
       * recieptionTime
       * costFlag
       * minChrgAmt
       * Price
       * multiple
       */
      relationships.forEach((relationship, rIndex) => {
        // GROUP BY MIN COUPON LIST
        // Store results of each set, using to compare
        let peopleCellResults = []
        // APPLY EACH SET
        const tempRemainingSubsidys = remainingSubsidys ? cloneDeep(remainingSubsidys) : [];
        tempRemainingSubsidys.forEach((couopon) => {
          // CALCULATE DISCOUNT AMOUNT OF EACH MIN SET
          const result = this.$_couponMixin_calculateCouponAmt({
            people: relationship,
            remainingSubsidys: tempRemainingSubsidys,
            requiredCoupon: couopon,
            options
          })
          if (result && result.totalDiscountAmount) {
            peopleCellResults.push(result)
          }
        })
        // FIND BEST SET OF COUPON
        peopleCellResults = peopleCellResults.sort(
          (a, b) => b.totalDiscountAmount - a.totalDiscountAmount
          )
        if (peopleCellResults.length) {
          const selectedResult = peopleCellResults[0]
          relationships[rIndex] = selectedResult.people
          remainingSubsidys = cloneDeep(selectedResult.remainingSubsidys)
          totalDiscountAmount += selectedResult.totalDiscountAmount
          totalAppliedCouponPrice += selectedResult.totalAppliedCouponPrice
          totalForceUseDiscount += selectedResult.totalForceUseDiscount
        }
      })

      // 元の並びに戻す（宿泊日昇順、ルームNo昇順、ID昇順）
      relationships = relationships.sort((a, b) => {
        if (a.stayDay < b.stayDay) return -1
        if (a.stayDay > b.stayDay) return 1
        if (a.roomNo < b.roomNo) return -1
        if (a.roomNo > b.roomNo) return 1
        if (a.id < b.id) return -1
        if (a.id > b.id) return 1
        return 0
      })
      // done apply coupons for relationship
      stayNightDetails = stayNightDetails.map((night) => {
        const filterRelationshipByStayDays = relationships.filter(
          (r) => r.stayDay === night.stayDay
        )
        night.coupons = night.coupons.map((coupon) => {
          coupon.availableData.priceList = coupon.availableData.priceList.map((price) => {
            // cumulate useCnt
            let useCnt = 0
            if (coupon.availableData.requestType === '01') {
              filterRelationshipByStayDays.forEach((people) => {
                people.appliedCoupons.forEach((aplCoupon) => {
                  if (
                    coupon.availableData.subsidyId ===
                      aplCoupon.availableData.subsidyId &&
                    price.subsidyPriceId === aplCoupon.applyPrice.subsidyPriceId
                  ) {
                    useCnt += aplCoupon.applyPrice.useCnt
                  }
                })
              })
            } else {
              filterRelationshipByStayDays.forEach((people) => {
                people.appliedCoupons.forEach((aplCoupon) => {
                  if (
                    coupon.availableData.subsidyId ===
                      aplCoupon.availableData.subsidyId &&
                    price.subsidyPriceId === aplCoupon.applyPrice.subsidyPriceId &&
                    price.relationshipCode === people.relationshipCode
                  ) {
                    useCnt += aplCoupon.applyPrice.useCnt
                  }
                })
              })
            }

            price.useCnt = useCnt

            return price
          })

          night.rooms = night.rooms.map((room) => {
            filterRelationshipByStayDays.forEach((people) => {
              const roomNo = people.roomNo
              const stayDay = people.stayDay
              if (room.roomNo === roomNo && night.stayDay === stayDay) {
                room.relationships = room.relationships.map((rel) => {
                  if (rel.id === people.id) {
                    rel.discount = people.discount
                    rel.subsidyPrice = people.subsidyPrice
                    rel.appliedCoupons = people.appliedCoupons
                    rel.priceList = people.priceList
                  }
                  return rel
                })
              }
            })
            return room
          })
          return coupon
        })
        return night
      })
      return {
        stayNightDetails,
        totalDiscountAmount,
        totalAppliedCouponPrice,
        totalForceUseDiscount,
        remainingSubsidys
      }
    },

    $_couponMixin_mapNightPrice({
      stayNightDetails,
      stayDay,
      stayNights,
      vacancyCalendar
    }) {
      const data = JSON.parse(JSON.stringify(stayNightDetails))
      data.forEach((night, i) => {
        const setStayDay = night.stayDay
        const cloneNight = cloneDeep(night)

        cloneNight.rooms = cloneNight.rooms.map((room) => {
          const selectedDaysInfo = this.$_couponMixin_updateSelectedDaysInfo(
            stayDay,
            stayNights,
            room.vacancyCalendar
          )

          const vacancyDayData = selectedDaysInfo[i]

          let roomPrice = 0;
          if (vacancyDayData.roomPrice) {
            const tempRelationships = room.relationships;
            // 室単価を人数で割り、1人当たりの価格を算出(#58666)
            roomPrice = Math.floor(vacancyDayData.roomPrice / tempRelationships.length);
          }
          room.relationships = room.relationships?.map((relation) => {
            if (relation.isMember && !relation.isChildren) {

              relation['stayDay'] = setStayDay
              relation['roomNo'] = room.roomNo
              if (roomPrice) {
                // 部屋単価の場合(人単価の場合、roomPriceはnull)
                relation['price'] = roomPrice
              } else {
                // 人単価の場合
                relation['price'] = vacancyDayData.price
              }
              relation['discount'] = 0
              relation['subsidyPrice'] = 0
              relation['appliedCoupons'] = []
            } else if (!relation.isMember && !relation.isChildren) {

              relation['stayDay'] = setStayDay
              relation['roomNo'] = room.roomNo
              if (roomPrice) {
                // 室単価の場合(人単価の場合、roomPriceはnull)
                relation['price'] = roomPrice
              } else {
                // 人単価の場合
                relation['price'] = vacancyDayData.adultPrice
              }
              relation['discount'] = 0
              relation['subsidyPrice'] = 0
              relation['appliedCoupons'] = []
            } else if (relation.isMember && relation.isChildren) {

              relation['stayDay'] = setStayDay
              relation['roomNo'] = room.roomNo
              if (roomPrice) {
                // 部屋単価の場合(人単価の場合、roomPriceはnull)
                relation['price'] = roomPrice
              } else {
                // 人単価の場合
                relation['price'] = this.getMemberChildPrice(
                  relation.chldType,
                  vacancyDayData.childrenPriceTable
                )
              }
              relation['discount'] = 0
              relation['subsidyPrice'] = 0
              relation['appliedCoupons'] = []
            } else if (!relation.isMember && relation.isChildren) {

              relation['stayDay'] = setStayDay
              relation['roomNo'] = room.roomNo
              if (roomPrice) {
                // 部屋単価の場合(人単価の場合、roomPriceはnull)
                relation['price'] = roomPrice
              } else {
                // 人単価の場合
                relation['price'] = this.getVisitorChildPrice(
                  relation.chldType,
                  vacancyDayData.childrenPriceTable
                )
              }
              relation['discount'] = 0
              relation['subsidyPrice'] = 0
              relation['appliedCoupons'] = []
            }
            return relation
          }) || []
          return room
        })
        data[i] = cloneNight
      })
      return data
    },

    /**
      * 補助金を最大限使用する補助金リストを作成し、
      * 補助金設定(未満投入、会員最低負担額、残金額、残枚数など)に従って補助金適用を行い適用結果を返す
      */
    $_couponMixin_calculateCouponAmt({
      people,
      remainingSubsidys,
      requiredCoupon,
      options = {
        applyOptional: true,
        applyType: 'auto'
      }
    }) {

      let totalForceUseDiscount = 0;
      let totalDiscountAmount = 0;
      let totalAppliedCouponPrice = 0;
      people = cloneDeep(people);
      // 引数の補助金の会員最低負担額が数値であれば、その値を代入し、
      // それ以外の場合は0を代入する
      const globalMin = requiredCoupon.availableData.minChargeAmt | 0;
      // INIT COUPON SET
      let tempSubsidyList = cloneDeep(remainingSubsidys);
      // 強制補助金、会員最低負担額が設定されていない補助金、requiredCouponの会員最低負担額よりも会員最低負担額が小さい補助金情報でリストを再度作成する
      tempSubsidyList = tempSubsidyList.filter((sbsd) =>
        sbsd.availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED ||  !sbsd.availableData.minChargeAmt || sbsd.availableData.minChargeAmt <= globalMin
      );

      // 会員情報から続柄名と続柄IDを取得して変数に代入し、いずれかの値が無い場合にはreturnする。
      const relationshipName = get(people, 'relationship.relationshipName', null)
      const relationshipId = get(people, 'relationship.relationshipId', null)
      if (!relationshipId || !relationshipName) {
        return
      }

      // 補助金を最大限使用する
      const bestChosenCouponData = this.$_couponMixin_findBestChosenCouponSet({
        remainingSubsidys: tempSubsidyList,
        peopleCell: people,
        options: {
          ...options,
          stayDay: people.stayDay,
          requiredCoupon
        }
      })

      // bestChosenCouponData.couponSetを維持したまま、新規のベストチョイス補助金リストを作成
      const couponSet = bestChosenCouponData.couponSet.concat();
      const isMultiple = bestChosenCouponData.isMultiple; // 併用可/不可どちらを採用したかのフラグ

      // ベストチョイス補助金リストでループ処理を行う
      // この時、ベストチョイスは併用可否の判定のみがされている状態
      couponSet.forEach((subsidy) => {
        subsidy = cloneDeep(subsidy)
        let applyPrice = subsidy.applyPrice
        let discountAmount = null
        // 会員の支払い料金を補助単価で減算する
        const amountAfterCoupon = people.price - applyPrice.price

        // 実費未満投入不可の場合
        if (subsidy.availableData.costUnderChargeableFlg === 0 || subsidy.availableData.costUnderChargeableFlg === '0') {
          // 実費未満投入とならない場合、会員最低負担額を確認し、最低負担額以上であれば割引を適用する
          if (amountAfterCoupon >= 0) {
            if (amountAfterCoupon >= globalMin) {
              discountAmount = applyPrice.price;
            }
          }
        // 実費未満投入可の場合
        } else {
          // 会員最低負担額以上であれば割引を適用する
          // 会員最低負担額を下回る計算結果となる場合は使用できないので、割引を適用しない
          discountAmount = people.price > applyPrice.price ? applyPrice.price : people.price;
          if (amountAfterCoupon <= globalMin) {
            // 会員の支払額より補助単価が大きい場合は、会員の支払額を割引額として利用する
            // 補助単価が会員の支払い金額より小さい場合は、補助単価を割引額とする
            discountAmount = people.price - globalMin >= 0 ? people.price - globalMin : null;
            if(discountAmount >= 0) {
              people.price = globalMin;
              applyPrice.price = discountAmount;
              subsidy.price = discountAmount;
            }
          // } else {
          //   discountAmount =
          //     people.price - globalMin >= people.price
          //       ? people.price
          //       : people.price - globalMin
          //   discountAmount = discountAmount >= 0 ? discountAmount : 0;
          }
        }

        // 補助金の残金額
        let remainingAmount = subsidy.availableRemainingAmount;
        // 補助金の残枚数
        let remainingCount = subsidy.availableRemainingCount;
        // 残枚数がラベル側に定義されている場合（健保補助金）、
        // 残枚数、残金額の判定に使用するので、取得する
        let remainingCountLabel = get(
          subsidy,
          'scrennDisplayItemList.remainingCountLabel.value',
          null
        );

        let remainingAmountLabel = get(
          subsidy,
          'scrennDisplayItemList.remainingAmountLabel.value',
          null
        );

        if (remainingCountLabel) {
          const relationshipRemainings = remainingCountLabel.split(',').map((e) => {
            const x = e.split('|')
            return {
              name: x[0],
              remainingCount: x[1]
            }
          })
          const findRelationshipRemains = relationshipRemainings.filter(
            (r) => r.name === relationshipName
          )

          // #73708 #77667 健保補助金の適用条件に不備があるため改修
          if (findRelationshipRemains.length && !isNaN(findRelationshipRemains[0].remainingCount)) {
            // ラベル残回数がnullでない場合に代入
            const relationshipRemainingCount = +(findRelationshipRemains[0].remainingCount)

            // 超過適用とならないよう、ラベル残回数を代入する条件は下記のどちらか
            // 1.残回数 > ラベル残回数のとき ※データ例：availableRemainingCount:4    remainingCountLabel:{value:上限回数|5,本人|2})
            // 2.残回数がnullのとき         ※データ例：availableRemainingCount:null remainingCountLabel:{value:上限回数|5,本人|2})
            if (remainingCount > relationshipRemainingCount || remainingCount == null) {
              remainingCount = relationshipRemainingCount
            }
          }
        }
        
        if (remainingAmountLabel) {
          const relationshipRemainings = remainingAmountLabel.split(',').map((e) => {
            const x = e.split('|')
            return {
              name: x[0],
              remainingAmount: x[1]
            }
          })
          const findRelationshipRemains = relationshipRemainings.filter(
            (r) => r.name === relationshipName
          )

          // #73708 #77667 健保補助金の適用条件に不備があるため改修
          if (findRelationshipRemains.length && !isNaN(findRelationshipRemains[0].remainingAmount)) {
            // ラベル残金額がnullでない場合に代入
            const relationshipRemainingAmount = +(findRelationshipRemains[0].remainingAmount)

            // 超過適用とならないよう、ラベル残金額を代入する条件は下記
            // 1.残金額 > ラベル残金額のとき ※データ例：availableRemainingAmount:8000 remainingAmountLabel:{value:上限金額|5000,本人|2000})
            // 2.残金額がnullのとき         ※データ例：availableRemainingAmount:null remainingAmountLabel:{value:上限金額|5000,本人|2000})
            if (remainingAmount > relationshipRemainingAmount || remainingAmount == null) {
              remainingAmount = relationshipRemainingAmount
            }
          }
        }

        // 値がおかしいのでコメントアウト
        // const couponStackAmount = couponDiscountMap[subsidy.availableData.subsidyId] || 0
        // const couponStackCount = couponCountMap[relationshipCountKey] || 0

        // 割引が適用できる場合は、以下の処理を実行する
        if (discountAmount !== null) {
          // 残金額が0以外の正の数で存在し、対象の補助金の合計利用残額が正の整数であり、割引額との関係性の
          // 整合性が取れている場合には、割引金額として、残金額から利用後の残金額を減算した値を割引額として適用する

          if (
              (remainingAmount === null || remainingAmount === 'null' || +remainingAmount > 0) &&
              (remainingCount === null || remainingCount === 'null' || +remainingCount > 0)
            ) {
            people.discount += discountAmount
            people.price -= discountAmount
            people.subsidyPrice += applyPrice.price
            if (!people.priceList) {
              people.priceList = {}
            }
            people.priceList[subsidy.availableData.subsidyId] = applyPrice
            people.priceList[subsidy.availableData.subsidyId].discount = discountAmount
            totalDiscountAmount += discountAmount
            if (subsidy.availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED) {
              totalForceUseDiscount += discountAmount
            }
            totalAppliedCouponPrice += applyPrice.price;
            tempSubsidyList.forEach((sbsd, index) => {
              if (
                sbsd.availableData.subsidyId === subsidy.availableData.subsidyId  &&
                sbsd.availableData.subsidyDetailId === subsidy.availableData.subsidyDetailId
              ) {
                tempSubsidyList[index].useCnt += 1

                if (remainingCountLabel) {
                  // #77667 健保補助金の残枚数制御
                  // 企業補助金は残枚数(availableRemainingCount)の減算制御だけ行う
                  let nameCount = 0;
                  const tempRemainingCountLabel = tempSubsidyList[index].scrennDisplayItemList.remainingCountLabel.value;
                  
                  const relationshipRemainings = tempRemainingCountLabel.split(',').map((e) => {
                    const x = e.split('|')
                    return {
                      tempName: x[0],
                      tempRemainingCount: x[1]
                    }
                  });

                  const findRelationshipRemains = relationshipRemainings.map((r) => {
                    if(r.tempName === relationshipName) {
                      // #73708 健保補助金の残枚数の計算に不備があったため条件追加
                      if (r.tempRemainingCount !== 'null') {
                        // ラベルの続柄ごとの上限が設定されているため減算 ※データ例：remainingCountLabel:{value:上限回数|5,本人|3})
                        r.tempRemainingCount = +r.tempRemainingCount - 1;
                      } else if (remainingCount !== null) {
                        // nullを数値変換するとNaNになるため利用可能残枚数から減算 ※データ例：remainingCountLabel:{value:上限回数|null,本人|null})
                        r.tempRemainingCount = remainingCount - 1
                      }
                      // 続柄ごとの上限設定あるため加算
                      nameCount++;
                    }
                    return r;
                  });

                  // 続柄のラベルが存在しなかったとき
                  if(nameCount < 1) {
                    const remainingLimitCountLabelItem = findRelationshipRemains.filter(
                      (r) => r.tempName === '上限回数'
                    )
                    
                    let tempRemainingCount = remainingCount

                    // ラベル上限回数と残回数を比較して値が小さいほうを適用させる
                    if (remainingLimitCountLabelItem.length && !isNaN(remainingLimitCountLabelItem[0].tempRemainingCount)) {
                      // ラベル残回数がnullでない場合に代入
                      const relationshipRemainingCount = +(remainingLimitCountLabelItem[0].tempRemainingCount)

                      // 超過適用とならないよう、ラベル残回数を代入する条件は下記のどちらか
                      // 1.残回数 > ラベル残回数のとき ※データ例：availableRemainingCount:4    remainingCountLabel:{value:上限回数|5,本人|2})
                      // 2.残回数がnullのとき         ※データ例：availableRemainingCount:null remainingCountLabel:{value:上限回数|5,本人|2})
                      if (remainingCount > relationshipRemainingCount || remainingCount == null) {
                        tempRemainingCount = relationshipRemainingCount
                      }
                    }
                    // nullでないときは減算する
                    if (tempRemainingCount) {
                      tempRemainingCount = tempRemainingCount - 1
                    }

                    // 新規追加するラベル上限回数
                    const newRemainingCountLabelItem = {
                      tempName: relationshipName,
                      tempRemainingCount: tempRemainingCount
                    }
                    findRelationshipRemains.push(newRemainingCountLabelItem);
                  }

                  let concatenatedString = findRelationshipRemains.map(item => `${item.tempName}|${item.tempRemainingCount},`).join('');
                  let lastCommaIndex = concatenatedString.lastIndexOf(",");
                  if (lastCommaIndex !== -1) {
                    concatenatedString = concatenatedString.substring(0, lastCommaIndex) + concatenatedString.substring(lastCommaIndex + 1);
                  }

                  tempSubsidyList[index].scrennDisplayItemList.remainingCountLabel.value = concatenatedString;
                }
                // #77667 企業補助金、健保補助金どちらも利用可能残回数がnullでない場合は減算する
                if (tempSubsidyList[index].availableRemainingCount !== null) {
                  tempSubsidyList[index].availableRemainingCount -= 1
                }
                
                if (remainingAmountLabel) {
                  // #77667 健保補助金の残金額制御
                  // 企業補助金は残金額(availableRemainingAmount)の減算制御だけ行う
                  let nameCount = 0;
                  const tempRemainingAmountLabel = tempSubsidyList[index].scrennDisplayItemList.remainingAmountLabel.value;
                  const relationshipRemainings = tempRemainingAmountLabel.split(',').map((e) => {
                    const x = e.split('|')
                    return {
                      tempName: x[0],
                      tempRemainingAmount: x[1]
                    }
                  });

                  const findRelationshipRemains = relationshipRemainings.map((r) => {
                    if(r.tempName === relationshipName) {
                      // #73708 健保補助金の残金額の計算に不備があったため条件追加
                      if (r.tempRemainingAmount !== 'null') {
                        // ラベルの続柄ごとの上限が設定されているため減算 ※データ例：remainingAmountLabel:{value:上限金額|10000,本人|2500})
                        r.tempRemainingAmount = +r.tempRemainingAmount - discountAmount;
                      } else if (remainingAmount !== null) {
                        // nullを数値変換するとNaNになるため利用可能残金額から減算 ※データ例：remainingAmountLabel:{value:上限金額|null,本人|null})
                        r.tempRemainingAmount = remainingAmount - discountAmount
                      }
                      // 続柄ごとの上限設定あるため加算
                      nameCount++;
                    }
                    return r;
                  });

                  if(nameCount < 1) {
                    const remainingLimitAmountLabelItem = findRelationshipRemains.filter(
                      (r) => r.tempName === '上限金額'
                    )
                    
                    let tempRemainingAmount = remainingAmount

                    // ラベル上限金額と残金額を比較して値が小さいほうを適用させる
                    if (remainingLimitAmountLabelItem.length && !isNaN(remainingLimitAmountLabelItem[0].tempRemainingAmount)) {
                      const relationshipRemainingAmount = +(remainingLimitAmountLabelItem[0].tempRemainingAmount)

                      // 超過適用とならないよう、ラベル残金額を代入する条件は下記
                      // 1.残金額 > ラベル残金額のとき ※データ例：availableRemainingAmount:8000 remainingAmountLabel:{value:上限金額|5000,本人|2000})
                      // 2.残金額がnullのとき         ※データ例：availableRemainingAmount:null remainingAmountLabel:{value:上限金額|5000,本人|2000})
                      if (remainingAmount > relationshipRemainingAmount || remainingAmount == null) {
                        tempRemainingAmount = relationshipRemainingAmount
                      }
                    }

                    // nullでないときは減算する
                    if (tempRemainingAmount) {
                      tempRemainingAmount = tempRemainingAmount - discountAmount
                    }

                    // 新規追加するラベル上限金額
                    const newRemainingAmountLabelItem = {
                      tempName: relationshipName,
                      tempRemainingAmount: tempRemainingAmount
                    }
                    findRelationshipRemains.push(newRemainingAmountLabelItem);
                  }

                  let concatenatedString = findRelationshipRemains.map(item => `${item.tempName}|${item.tempRemainingAmount},`).join('');
                  let lastCommaIndex = concatenatedString.lastIndexOf(",");
                  if (lastCommaIndex !== -1) {
                    concatenatedString = concatenatedString.substring(0, lastCommaIndex) + concatenatedString.substring(lastCommaIndex + 1);
                  }
                  
                  tempSubsidyList[index].scrennDisplayItemList.remainingAmountLabel.value = concatenatedString;
                }
                // #77667 企業補助金、健保補助金どちらも利用可能残金額がnullでない場合は減算する
                if (tempSubsidyList[index].availableRemainingAmount !== null) {
                  tempSubsidyList[index].availableRemainingAmount -= discountAmount
                }
              }
            })
            const appliedCoupon = cloneDeep(subsidy)
            appliedCoupon['applyPrice'] = cloneDeep(applyPrice)
            appliedCoupon['applyPrice']['useCnt'] = 1
            appliedCoupon['appliedAmt'] = discountAmount
            appliedCoupon['useCnt'] = 1

            people.appliedCoupons.push(appliedCoupon)

            // count applied coupon number
            // 値がおかしいので、コメントアウト
            // if (couponCountMap[relationshipCountKey]) {
            //   couponCountMap[relationshipCountKey] += 1
            // } else {
            //   couponCountMap[relationshipCountKey] = 1
            // }
            // count applied coupon amount
            // 値がおかしいので、コメントアウト
            // if (couponDiscountMap[subsidy.availableData.subsidyId]) {
            //   couponDiscountMap[subsidy.availableData.subsidyId] += discountAmount
            // } else {
            //   couponDiscountMap[subsidy.availableData.subsidyId] = discountAmount
            // }
          }
        }
      })

      return {
        people,
        totalForceUseDiscount,
        totalDiscountAmount,
        totalAppliedCouponPrice,
        remainingSubsidys: tempSubsidyList,
        isMultiple: isMultiple, // 併用可/不可どちらを採用したかのフラグ
      }
    },

    $_couponMixin_getSortedPeopleList({
      stayDay,
      stayNights,
      stayRoomDetails = [],
      vacancyCalendar
    }) {
      const nights = []
      for (let i = 0; i < stayNights; i++) {
        const verifyDay = moment(stayDay).add(i, 'days')
        const selectedDaysInfo = this.$_couponMixin_updateSelectedDaysInfo(
          stayDay,
          stayNights,
          vacancyCalendar
        )
        const vacancyDayData = selectedDaysInfo[i]
        let nighPeoples = []

        let oneNightPeopleList = []
        stayRoomDetails.forEach((room) => {
          oneNightPeopleList = oneNightPeopleList.concat(room.relationships)
        })

        oneNightPeopleList.forEach((p) => {
          const people = cloneDeep(p)
          if (people.isMember && !people.isChildren) {

            people['price'] = vacancyDayData.price
            people['discount'] = 0
            people['subsidyPrice'] = 0
            people['appliedCoupons'] = []
            nighPeoples.push(people)
          } else if (!people.isMember && !people.isChildren) {

            people['price'] = vacancyDayData.adultPrice
            people['discount'] = 0
            people['subsidyPrice'] = 0
            people['appliedCoupons'] = []
            nighPeoples.push(people)
          } else if (people.isMember && people.isChildren) {

            people['price'] = this.getMemberChildPrice(
              people.chldType,
              vacancyDayData.childrenPriceTable
            )
            people['discount'] = 0
            people['subsidyPrice'] = 0
            people['appliedCoupons'] = []
            nighPeoples.push(people)
          } else if (!people.isMember && people.isChildren) {

            people['price'] = this.getVisitorChildPrice(
              people.chldType,
              vacancyDayData.childrenPriceTable
            )
            people['discount'] = 0
            people['subsidyPrice'] = 0
            people['appliedCoupons'] = []
            nighPeoples.push(people)
          }
        })

        nighPeoples = nighPeoples.sort((a, b) => b.price - a.price)

        const nightData = {
          stayDay: verifyDay.format(this.dateFormat),
          peoples: nighPeoples
        }
        nights.push(nightData)
      }
      return nights
    },

    // この処理の意味が、最低負担額をキーとする連想配列を作成している
    // キーの重複により、最後に上書きした補助金情報しか持てないので削除
    // 処理内にこの補助金リストが必要な箇所は存在しない
    // $_couponMixin_findCouponMinSet(coupons = []) {
    //   coupons = cloneDeep(coupons)
    //   const minSet = {}
    //   coupons.forEach((c) => {
    //     const min = get(c, 'availableData.minChargeAmt', 0) || 0
    //     if (minSet[min] === undefined) {
    //       minSet[min] = c
    //     }
    //   })
    //   return minSet
    // },

    $_couponMixin_updateSelectedDaysInfo(stayDay, stayNights, vacancyCalendar) {
      const selectedDaysTemp = []
      const selectedDays = cloneDeep(
        this.$_couponMixin_getSelectedDays(stayDay, stayNights)
      )
      if (selectedDays.length > 0) {
        selectedDays.splice(-1)
      }
      const vacancyCalendars = vacancyCalendar?.vacancyCalendars || []
      selectedDays.forEach((day) => {
        const dayInfo = {
          stayDay: day,
          childTypePrice: {},
          roomPrice: null,
          price: null,
          adultPrice: null,
          boneSubsidy: null,
          stock: null,
          reservationDiv: null,
          childrenPriceTable: []
        }
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
            const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
            dayInfo['childTypePrice'] = {}
            if (!roomPrice) {
              dayInfo['childTypePrice']['childrenType10'] = this.getMemberChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType15'] = this.getMemberChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType20'] = this.getMemberChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType30'] = this.getMemberChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType40'] = this.getMemberChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType50'] = this.getMemberChildPrice(
                'f',
                vacancy.childrenPriceTable
              )

              dayInfo['childTypePrice']['visitorType10'] = this.getVisitorChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType15'] = this.getVisitorChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType20'] = this.getVisitorChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType30'] = this.getVisitorChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType40'] = this.getVisitorChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType50'] = this.getVisitorChildPrice(
                'f',
                vacancy.childrenPriceTable
              )
            }
            dayInfo.adultPrice = vacancy.adultPrice
            dayInfo.boneSubsidy = vacancy.boneSubsidy
            dayInfo.price = vacancy.price
            dayInfo.roomPrice = vacancy.roomPrice
            dayInfo.stock = vacancy.stock
            dayInfo.reservationDiv = vacancy.reservationDiv
            dayInfo.childrenPriceTable = vacancy.childrenPriceTable
          }
        })
        selectedDaysTemp.push(dayInfo)
      })
      return selectedDaysTemp
    },

    $_couponMixin_getSelectedDays(day, stayNights) {
      if (day) {
        const stayDay = moment(day).format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },

    $_couponMixin_getCouponPrice(peopleCell, coupon, options = null) {
      const stayRoomDetails =
        get(this.bsAppState.bs_app_02_001, 'stayRoomDetails', null) || []
      const availableData = coupon.availableData

      let personAccompanyFlg = false
      stayRoomDetails.forEach((room) => {
        room.relationships.forEach((r) => {
          if (+get(r, 'relationship.relationshipId') === 0) {
            personAccompanyFlg = true
          }
        })
      })
      if (personAccompanyFlg === false && +availableData.personAccompanyFlg === 1) {
        return null
      }
      if (!peopleCell || !availableData) {
        return
      }

      let price = null
      const relationshipId = String(peopleCell.relationshipCode.split('-')[1]).trim()
      const relationshipLevel = String(peopleCell.relationshipCode.split('-')[2]).trim()
      const relationshipName = get(peopleCell, 'relationship.relationshipName', null)
      const stayDay = moment(peopleCell.stayDay)
      const applicableDegreeCnt = availableData.applicableDegreeCnt

      let priceList = availableData.priceList || []
      priceList = priceList.filter(
        (e) =>
          moment(e.limApplicableDateFrom).isSameOrBefore(stayDay, 'day') &&
          moment(e.limApplicableDateTo).isSameOrAfter(stayDay, 'day')
      )
      let canFindSamePrice = true
      if (options.applyType === 'auto' || availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED) {
        // SELECT BEST CHOSEN
        if (+relationshipId === 0) {
          // CHÍNH CHỦ - NGƯỜI LỚN
          if (!peopleCell.isChildren) {
            //
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.OWNER &&
                e.ageType === COUPON_AGE_TYPE.ADULT
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          } else {
            // CHÍNH CHỦ - TRẺ EM
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.OWNER &&
                e.ageType === COUPON_AGE_TYPE.CHILDREN
            )
            if (
              !availableData.minTgtAge ||
              (availableData.minTgtAge && +peopleCell.age >= +availableData.minTgtAge)
            ) {
              price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
            } else {
              canFindSamePrice = false
            }
          }

          if (!price) {
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.OWNER &&
                e.ageType === COUPON_AGE_TYPE.BOLT
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }
        } else if (
          applicableDegreeCnt === null ||
          +relationshipLevel <= applicableDegreeCnt
        ) {
          if (!peopleCell.isChildren) {
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.FAMILY &&
                e.ageType === COUPON_AGE_TYPE.ADULT
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          } else {
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.FAMILY &&
                e.ageType === COUPON_AGE_TYPE.CHILDREN
            )
            if (
              !availableData.minTgtAge ||
              (availableData.minTgtAge && +peopleCell.age >= +availableData.minTgtAge)
            ) {
              price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
            } else {
              canFindSamePrice = false
            }
          }

          if (!price) {
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.FAMILY &&
                e.ageType === COUPON_AGE_TYPE.BOLT
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }
        }
        if (
          !price &&
          canFindSamePrice &&
          (applicableDegreeCnt === null || +relationshipLevel <= applicableDegreeCnt)
        ) {
          priceList
            .filter((e) => e.priceType === COUPON_PRICE_TYPE.BOLT)
            .forEach((el) => {
              if (
                !price &&
                !peopleCell.isChildren &&
                el.ageType === COUPON_AGE_TYPE.ADULT
              ) {
                price = el
              } else if (
                !price &&
                peopleCell.isChildren &&
                el.ageType === COUPON_AGE_TYPE.CHILDREN
              ) {
                if (
                  !availableData.minTgtAge ||
                  (availableData.minTgtAge && +peopleCell.age >= +availableData.minTgtAge)
                ) {
                  price = el
                }
              }
            })
          if (!price) {
            const filterPriceList = priceList.filter(
              (e) =>
                e.priceType === COUPON_PRICE_TYPE.BOLT &&
                e.ageType === COUPON_AGE_TYPE.BOLT
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }
        }
      } else if (options.applyType === 'manual' && availableData.requestType === '01') {

        if (+relationshipId === 0) {
          if (!peopleCell.isChildren) {
            const filterPriceList = priceList.filter(
              (p) =>
                p.priceType === COUPON_PRICE_TYPE.OWNER &&
                p.ageType === COUPON_AGE_TYPE.ADULT &&
                p.remaining &&
                p.selectUseCnt &&
                p.stayDay === peopleCell.stayDay
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          } else {
            const filterPriceList = priceList.filter(
              (p) =>
                p.priceType === COUPON_PRICE_TYPE.OWNER &&
                p.ageType === COUPON_AGE_TYPE.CHILDREN &&
                p.remaining &&
                p.selectUseCnt &&
                p.stayDay === peopleCell.stayDay
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }
          if (!price) {
            const filterPriceList = priceList.filter(
              (p) =>
                p.priceType === COUPON_PRICE_TYPE.OWNER &&
                p.ageType === COUPON_AGE_TYPE.BOLT &&
                p.remaining &&
                p.selectUseCnt &&
                p.stayDay === peopleCell.stayDay
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }

          if (!price) {
            if (!peopleCell.isChildren) {
              const filterPriceList = priceList.filter(
                (p) =>
                  p.priceType === COUPON_PRICE_TYPE.BOLT &&
                  p.ageType === COUPON_AGE_TYPE.ADULT &&
                  p.remaining &&
                  p.stayDay === peopleCell.stayDay
              )
              price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
            } else {
              const filterPriceList = priceList.filter(
                (p) =>
                  p.priceType === COUPON_PRICE_TYPE.BOLT &&
                  p.ageType === COUPON_AGE_TYPE.CHILDREN &&
                  p.remaining &&
                  p.stayDay === peopleCell.stayDay
              )
              price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
            }
          }
        } else if (+relationshipLevel >= 0 && (applicableDegreeCnt === null || +relationshipLevel <= applicableDegreeCnt)) {
          if (!peopleCell.isChildren) {
            const filterPriceList = priceList.filter(
              (p) =>
                p.ageType === COUPON_AGE_TYPE.ADULT &&
                p.remaining &&
                p.selectUseCnt &&
                p.stayDay === peopleCell.stayDay
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          } else {
            const filterPriceList = priceList.filter(
              (p) =>
                p.ageType === COUPON_AGE_TYPE.CHILDREN &&
                p.remaining &&
                p.selectUseCnt &&
                p.stayDay === peopleCell.stayDay
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }

          if (!price) {
            const filterPriceList = priceList.filter(
              (p) =>
                p.ageType === COUPON_AGE_TYPE.BOLT &&
                p.remaining &&
                p.selectUseCnt &&
                p.stayDay === peopleCell.stayDay
            )
            price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
          }
        }

        if (
          !price &&
          (applicableDegreeCnt === null || +relationshipLevel <= applicableDegreeCnt)
        ) {
          const filterPriceList = priceList.filter(
            (p) =>
              p.priceType === COUPON_PRICE_TYPE.BOLT &&
              p.ageType === COUPON_AGE_TYPE.BOLT &&
              p.remaining &&
              p.stayDay === peopleCell.stayDay
          )
          price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
        }
      } else if (options.applyType === 'manual' && availableData.requestType !== '01') {

        const filterPriceList = priceList.filter(
          (p) =>
            p.selectUseCnt &&
            p.remaining &&
            p.relationship &&
            p.stayDay === peopleCell.stayDay &&
            p.relationshipCode === peopleCell.relationshipCode
        )
        price = filterPriceList.length ? cloneDeep(filterPriceList[0]) : null
      }

      // 補助金単価分の残金が残っているか判定
      // 補助金の残金額
      let remainingAmount = coupon.availableRemainingAmount;
      // 健保の場合はラベル側に定義
      let remainingAmountLabel = get(
        coupon,
        'scrennDisplayItemList.remainingAmountLabel.value',
        null
      );
      if (remainingAmountLabel) {
        const relationshipRemainings = remainingAmountLabel.split(',').map((e) => {
          const x = e.split('|')
          return {
            name: x[0],
            remainingAmount: x[1]
          }
        })
        const findRelationshipRemains = relationshipRemainings.filter(
          (r) => r.name === relationshipName
        )

        // #73708 #77667 健保補助金の適用条件に不備があるため改修
        if(findRelationshipRemains.length && !isNaN(findRelationshipRemains[0].remainingAmount)) {
          // ラベル残金額がnullでない場合に代入
          const relationshipRemainingAmount = +(findRelationshipRemains[0].remainingAmount)
          // 超過適用とならないよう、ラベル残金額を代入する条件は下記
          // 1.残金額 > ラベル残金額のとき ※データ例：availableRemainingAmount:8000 remainingAmountLabel:{value:上限金額|5000,本人|2000})
          // 2.残金額がnullのとき         ※データ例：availableRemainingAmount:null remainingAmountLabel:{value:上限金額|5000,本人|2000})
          if (remainingAmount > relationshipRemainingAmount || remainingAmount == null) {
            console.log("残金額変更前 remainingAmount:", remainingAmount)
            remainingAmount = relationshipRemainingAmount
            console.log("残金額変更後 remainingAmount:", remainingAmount)
          }
        }
      }
      // 残額有且つ補助単価に満たない場合は補助金額を残額で設定
      if(remainingAmount != null && price?.price > remainingAmount)
      {
        price.price = remainingAmount
      }
      return price
    },

    // ベストチョイスをセットする為の関数
    // 引数のstayNightDetailsは利用しない
    $_couponMixin_findBestChosenCouponSet({
      remainingSubsidys,
      peopleCell,
      options = {
        applyOptional: true,
        stayDay: null,
        applyType: 'auto'
      }
    }) {
      // 宿泊者毎の情報を整理したpeopleCellの支払額をクローンし、jsでfalse判定となる値の場合は0をセット
      let pricePeopleCell = cloneDeep(peopleCell?.price || 0);
      // ベストチョイスの補助金情報格納用変数
      let couponSet = []
      // 併用の可否判定に使用する
      let allowMultiple = true
      let isMultiple = true; // 併用可/不可どちらを採用したかのフラグ（初期値は併用可）

      // 強制と任意の仕分け
      // 強制補助金を取得
      let forceUseCoupons = cloneDeep(remainingSubsidys).filter(
        (c) =>
          (c.availableRemainingCount === null || c.availableRemainingCount) &&
          c.availableData &&
          c.availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED
      )

      // 任意補助金を取得
      let optionalCoupons = cloneDeep(remainingSubsidys).filter(
        (c) =>
          (c.availableRemainingCount === null || c.availableRemainingCount) &&
          c.availableData &&
          c.availableData.usedFormDiv !== this.CONST_DATA.USED_FORM_DIV.FORCED
      )

      /**
       * 任意補助金を選択して利用する場合、
       * 各任意補助金のpriceListの選択枚数がfalseとなる場合には0をその他は単価を利用し、
       * 残金額を加算し、合計が0より大きい補助金でフィルタリング
       */
      if (options.applyType === 'manual') {
        optionalCoupons = optionalCoupons.filter(
          (c) =>
            c.availableData.priceList
              .map((p) => p.remaining || 0)
              .reduce((a, b) => a + b, 0) > 0
        )
      }

      // 強制補助金を取り出す
      if (forceUseCoupons.length) {
        // required to use
        forceUseCoupons = forceUseCoupons
          .map((c) => {
            c.applyPrice = this.$_couponMixin_getCouponPrice(peopleCell, c, options)
            c.price = c.applyPrice ? c.applyPrice.price : 0
            return c
          })
          .filter((c) => c.applyPrice)
        // 高い順に並び替え
        forceUseCoupons = forceUseCoupons.sort((a, b) => b.price - a.price)

        // 強制補助金の単価が最も高いものしか併用可否を判定していない
        // => 適用単価が最も高くなる必要があるため、強制補助金であれば最も単価の高いものが併用可能でなければ
        // 併用不可が選択されることはないため、第一要素を取得して判定する
        if (+get(forceUseCoupons, '[0].availableData.multipleUnusableFlg', null) === 1) {
          // not allow to use with other coupons 併用不可
          couponSet = [forceUseCoupons[0]]
          allowMultiple = false
        } else {
          // 未満投入不可かつ補助金単価がpeopleCellの支払額より大きいデータは除外する条件を追加
          couponSet = forceUseCoupons.filter(
            (c) => 
              +c.availableData.multipleUnusableFlg === 0
              && !(+c.availableData.costUnderChargeableFlg === 0  && c.price > pricePeopleCell)
          )
          // 併用可能なもののみでベストチョイスを作成している
          // forceUseCouponsから「未満投入不可かつ補助金単価がpeopleCellの支払額より大きいデータを除外」したcouponSetに変更
          couponSet.forEach(item=>{
            if(+item?.availableData?.multipleUnusableFlg === 0){
              pricePeopleCell -= item.price
            } 
          });
        }
      }

      // 任意補助金を取り出す
      if (options && options.applyOptional !== false && optionalCoupons.length) {
        optionalCoupons = optionalCoupons
          .map((c) => {
            c.applyPrice = this.$_couponMixin_getCouponPrice(peopleCell, c, options)
            c.price = c.applyPrice ? c.applyPrice.price : 0
            return c
          })
          .filter((c) => c.applyPrice)
        // 高い順に並び替え
        optionalCoupons = optionalCoupons.sort((a, b) => {
          return b.price - a.price
        })
        // 既に強制補助金が適用されている場合は、任意補助金も併用不可の補助金が利用できない為、
        // 併用可能の補助金のみ取得する
        // 強制補助金も併用可能である必要がある
        if (couponSet.length) {
          if (allowMultiple) {
            optionalCoupons.forEach(optional=>{
              // 未満投入可の任意補助金が適用できないケースが発生したため、条件を分ける #54346

              // 未満投入可の補助金か && pricePeopleCellが0以上か && 補助金の残金額が残っているか && 複数使用可能か
              if(+optional.availableData.costUnderChargeableFlg === 1 && pricePeopleCell >= 0 &&
                (optional.availableRemainingAmount !== 0 || optional.availableRemainingCount !== 0) && optional?.availableData?.multipleUnusableFlg == 0)
              {
                pricePeopleCell -= optional.price

                // 強制と任意を一つの配列に格納していく
                couponSet = [
                  ...couponSet,
                  optional
                ]
              }
              // 未満投入不可の補助金か && 補助金利用上限を超えないか && 補助金の残金額が残っているか && 複数使用可能か
              if(+optional.availableData.costUnderChargeableFlg === 0 && pricePeopleCell - optional.price >= 0 &&
                (optional.availableRemainingAmount !== 0 || optional.availableRemainingCount !== 0) && optional?.availableData?.multipleUnusableFlg == 0)
              {
                pricePeopleCell -= optional.price

                // 強制と任意を一つの配列に格納していく
                couponSet = [
                  ...couponSet,
                  optional
                ]
              }
            })
          }
        } else {
          // 併用不可の任意補助金を取り出す
          const notAllowMultiCoupons = optionalCoupons.filter(
            (c) => +c.availableData.multipleUnusableFlg === 1
          )
          // 併用可の任意補助金を取り出す
          const allowMultiCoupons = optionalCoupons.filter(
            (c) => +c.availableData.multipleUnusableFlg === 0
          )
          // 割引額を格納するための変数
          // 本関数の実行後は最も高い割引額が代入される
          let maxDiscount = 0
          let selectCoupon = null
          // 併用不可の任意補助金を一つずつ取り出し、割引額が最大となるものを選択した補助金情報としてセットし、
          // 実行後の割引額を現状の最大割引額として変数に格納
          notAllowMultiCoupons.forEach((c) => {
            const discount = this.$_couponMixin_getCouponPrice(peopleCell, c, options)
            // find largest discount
            if (discount && maxDiscount < discount.price) {
              maxDiscount = discount.price
              selectCoupon = c
              selectCoupon.applyPrice = discount
              selectCoupon.price = maxDiscount
            }
          })
          // 併用できる場合は、割引額が加算されるので合計の割引額を格納する変数を定義
          let totalDiscount = 0
          // 併用可の補助金を取り出し、補助金情報にデータを追加していく
          allowMultiCoupons.forEach((c, idx) => {
            const discount = this.$_couponMixin_getCouponPrice(peopleCell, c, options)
            if (discount) {
              totalDiscount += discount.price
              allowMultiCoupons[idx].applyPrice = discount
              allowMultiCoupons[idx].price = discount?.price
            }
          })
          if (maxDiscount !== 0 || totalDiscount !== 0) {
            if (maxDiscount > totalDiscount) {
              couponSet = [selectCoupon]
              isMultiple = false; // 併用不可の補助金を採用
            } else {
              couponSet = [...allowMultiCoupons]
              isMultiple = true; // 併用可の補助金を採用
            }
          }
        }
      }
      return {
        couponSet: couponSet, // ベストチョイスの結果
        isMultiple: isMultiple, // 併用可/不可どちらを採用したかのフラグ
      }
    },

    $_couponMixin_manualApplyCoupon({
      stayDay,
      stayNights,
      coupons,
      vacancyCalendar,
      stayNightDetails,
      options = {
        applyOptional: true,
        applyType: 'auto'
      }
    }) {
      // optionsに任意補助金を選択するオプションを格納
      options = { ...options, ...{ applyType: 'manual' } }

      let totalDiscountAmount = 0
      let totalAppliedCouponPrice = 0
      let totalForceUseDiscount = 0
      let remainingSubsidys = cloneDeep(coupons)
      let bestChoiceResult = []; // ベストチョイスの結果保持用
      // 元のオブジェクトが参照されないようにコピーを作成して使用する
      stayNightDetails = cloneDeep(stayNightDetails)
      // map price
      // 各宿泊日毎の料金情報をマッピングした詳細情報を作成する
      stayNightDetails = this.$_couponMixin_mapNightPrice({
        stayNightDetails,
        stayDay,
        stayNights,
        vacancyCalendar
      })
      // GET PEOPLE PRICE
      let relationships = []
      stayNightDetails.forEach((night) => {
        night.rooms.forEach((room) => {
          room.relationships.forEach((r) => {
            // 「その他会員」の場合補助金適応外
            if (r.relationshipCode !== "C-205-9") {
              relationships.push(r)
            }
          })
        })
      })
      // SORT PEOPLE
      relationships = relationships.sort((a, b) => {
        return b.price - a.price
      })
      
      // LIMIT COUPONS WHEN MANUAL APPLICATION
      remainingSubsidys = remainingSubsidys.map((rmCoupon) => {
        // 強制補助金ならリターンする
        if (rmCoupon.availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED) {
          return rmCoupon
        } else {
          const rmPriceList = []
          // 補助金情報から抜き出した補助金情報と、宿泊日毎の詳細情報に格納している
          // 補助金情報を補助金IDで判定し、一致する補助金の場合に選択枚数・単価とpriceListを更新する
          // remainingSubsidyという名前だが残補助金情報では無いと思われる
          stayNightDetails.forEach((night) => {
            night.coupons.forEach((coupon) => {
              if (rmCoupon.availableData.subsidyId === coupon.availableData.subsidyId) {
                coupon.availableData.priceList.forEach((price) => {
                  let flag = false
                  // TODO
                  // 一度コメントアウトし、問題なければ削除する
                  // rmPriceList.forEach((rmPrice, index) => {
                  //   if (
                  //     rmPrice.subsidyDetailId === price.subsidyDetailId &&
                  //     rmPrice.subsidyPriceId === price.subsidyPriceId &&
                  //     price.selectUseCnt &&
                  //     price.remaining &&
                  //     rmPrice.stayDay === night.stayDay &&
                  //     rmPrice.relationshipCode === night.relationshipCode   <======= この値が無いので常にfalseになると思われる
                  //   ) {
                  //     flag = true
                  //     rmPriceList[index].remaining =
                  //       (rmPrice.remaining || 0) + (price.remaining || 0)
                  //     rmPriceList[index].selectUseCnt =
                  //       (rmPrice.selectUseCnt || 0) + (price.selectUseCnt || 0)
                  //   }
                  // })

                  // flagがfalseでpriceListにremainingとselectUseCntが存在する場合
                  // 申請する補助金のpriceListに値をオブジェクトを追加する
                  if (!flag && price.remaining && price.selectUseCnt && rmCoupon.availableData.subsidyDetailId === price.subsidyDetailId) {
                    rmPriceList.push({
                      ...price,
                      ...{
                        remaining: price.remaining || 0,
                        selectUseCnt: price.selectUseCnt || 0,
                        relationship: price.relationship,
                        relationshipCode: price.relationshipCode,
                        stayDay: night.stayDay
                      }
                    })
                  }
                })
              }
            })
          })
          rmCoupon.availableData.priceList = rmPriceList
          return rmCoupon
        }
      })

      // 会員情報のリストでループ処理を行う
      relationships.forEach((relationship, rIndex) => {
        // GROUP BY MIN COUPON LIST => 会員最低負担額でグルーピング
        // Store results of each set, using to compare
        let peopleCellResults = []
        // APPLY EACH SET
        const cloneRemainingSubsidys = remainingSubsidys ? cloneDeep(remainingSubsidys) : [];
        cloneRemainingSubsidys.forEach((coupon) => {
          // APPLY EACH SET
          let tempRemainingSubsidys = cloneDeep(remainingSubsidys)
          // 強制補助金かpriceListにremaining項目が存在している場合に、remainingの配列を生成し、全要素の和を変数に代入する
          tempRemainingSubsidys = tempRemainingSubsidys.filter((c) => {
            const remaining = c.availableData.priceList
              .map((p) => p.remaining || 0)
              .reduce((a, b) => a + b, 0)
            return c.availableData.usedFormDiv === this.CONST_DATA.USED_FORM_DIV.FORCED || remaining > 0
          })
          // CALCULATE DISCOUNT AMOUNT OF EACH MIN SET
          const result = this.$_couponMixin_calculateCouponAmt({
            people: relationship,
            remainingSubsidys: tempRemainingSubsidys,
            requiredCoupon: coupon,
            options
          })
          if (result && result.totalDiscountAmount) {
            peopleCellResults.push(result)
            bestChoiceResult.push(result) // ベストチョイスの結果を保持
          }
        })
        // FIND BEST SET OF COUPON
        peopleCellResults = peopleCellResults.sort(
          (a, b) => b.totalDiscountAmount - a.totalDiscountAmount
        )
        if (peopleCellResults.length) {
          const selectedResult = peopleCellResults[0]
          relationships[rIndex] = selectedResult.people
          remainingSubsidys = cloneDeep(selectedResult.remainingSubsidys)
          totalDiscountAmount += selectedResult.totalDiscountAmount
          totalAppliedCouponPrice += selectedResult.totalAppliedCouponPrice
          totalForceUseDiscount += selectedResult.totalForceUseDiscount
          const appliedCoupons = selectedResult.people.appliedCoupons
          remainingSubsidys.forEach((rmSubsidy, i) => {
            // remaining & useCnt
            selectedResult.remainingSubsidys.forEach((aplSubsidy) => {
              if (
                aplSubsidy.availableData.subsidyId === rmSubsidy.availableData.subsidyId &&
                aplSubsidy.availableData.subsidyDetailId === rmSubsidy.availableData.subsidyDetailId
              ) {
                remainingSubsidys[i].availableRemainingCount = aplSubsidy.availableRemainingCount
                remainingSubsidys[i].availableRemainingAmount = aplSubsidy.availableRemainingAmount
                remainingSubsidys[i].useCnt = aplSubsidy.useCnt
              }
            })

            appliedCoupons.forEach((aplSubsidy) => {
              if (
                aplSubsidy.availableData.subsidyId === rmSubsidy.availableData.subsidyId &&
                aplSubsidy.availableData.subsidyDetailId === rmSubsidy.availableData.subsidyDetailId
              ) {
                // CHECK PRICE LIST 
                const rmPriceList = cloneDeep(rmSubsidy.availableData.priceList)
                rmPriceList.forEach((rmPrice, j) => {
                  if (
                    aplSubsidy.applyPrice.subsidyDetailId === rmPrice.subsidyDetailId &&
                    aplSubsidy.applyPrice.subsidyPriceId === rmPrice.subsidyPriceId &&
                    aplSubsidy.applyPrice.stayDay === rmPrice.stayDay &&
                    (!aplSubsidy.applyPrice.relationshipCode ||
                      (rmPrice.relationshipCode &&
                        aplSubsidy.applyPrice.relationshipCode ===
                          rmPrice.relationshipCode))
                  ) {
                    rmPriceList[j].useCnt =
                      (rmPrice.useCnt || 0) + aplSubsidy.applyPrice.useCnt
                    rmPriceList[j].remaining -= aplSubsidy.applyPrice.useCnt
                  }
                })
                remainingSubsidys[i].availableData.priceList = rmPriceList
              }
            })
          })
        }
      })

      let isChangeUsePlan = false
      stayNightDetails = stayNightDetails.map((night) => {
        const filterRelationshipByStayDays = relationships.filter(
          (r) => r.stayDay === night.stayDay
        )
        night.coupons = night.coupons.map((coupon) => {
          coupon.availableData.priceList = coupon.availableData.priceList.map((price) => {
            // cumulate useCnt
            let useCnt = 0
            if (coupon.availableData.requestType === '01') {
              filterRelationshipByStayDays.forEach((people) => {
                people.appliedCoupons.forEach((aplCoupon) => {
                  if (
                    coupon.availableData.subsidyId ===
                      aplCoupon.availableData.subsidyId &&
                    price.subsidyPriceId === aplCoupon.applyPrice.subsidyPriceId
                  ) {
                    useCnt += aplCoupon.applyPrice.useCnt
                  }
                })
              })
            } else {
              filterRelationshipByStayDays.forEach((people) => {
                people.appliedCoupons.forEach((aplCoupon) => {
                  if (
                    coupon.availableData.subsidyId ===
                      aplCoupon.availableData.subsidyId &&
                    price.subsidyPriceId === aplCoupon.applyPrice.subsidyPriceId &&
                    price.relationshipCode === people.relationshipCode
                  ) {
                    useCnt += aplCoupon.applyPrice.useCnt
                  }
                })
              })
            }

            /**
             * 任意選択の枚数選択の可/不可を判定する
             */
            const stayDay = night.stayDay; // 適用日
            const people = filterRelationshipByStayDays.find(data => data.relationshipCode == price.relationshipCode)
            const peopleId = people && people.id ? people.id : null; // 適用されている人物のID（一律の場合はrelationshipCodeがなくpeopleに値が入らない）
            const subsidyId = coupon.availableData.subsidyId; // 枚数選択を制御するクーポンの補助金ID
            const subsidyPriceId = price.subsidyPriceId; // 枚数選択を制御する価格の単価ID
            const multipleUnusableFlg = coupon.availableData.multipleUnusableFlg; // 枚数選択を制御するクーポンの併用可/不可
            price.enabledChangeOptionalCouponCnt = this.$_couponMixin_checkEnabledChangeOptionalCouponCnt(
              bestChoiceResult,
              stayDay,
              peopleId,
              subsidyId,
              subsidyPriceId,
              multipleUnusableFlg,    
            ); // enabledChangeOptionalCouponCntに判定結果をセットする

            price.useCnt = useCnt;
            // Check select to use and actual used coupons
            if (
              !isNaN(price.selectUseCnt) &&
              price.selectUseCnt > 0 &&
              !isNaN(price.remaining) &&
              price.remaining > 0 &&
              useCnt !== price.selectUseCnt
            ) {
              isChangeUsePlan = true
              price.selectUseCnt = useCnt || 0
            }
            return price
          })

          night.rooms = night.rooms.map((room) => {
            filterRelationshipByStayDays.forEach((people) => {
              const roomNo = people.roomNo
              const stayDay = people.stayDay
              if (room.roomNo === roomNo && night.stayDay === stayDay) {
                room.relationships = room.relationships.map((rel) => {
                  if (rel.id === people.id) {
                    rel.discount = people.discount
                    rel.subsidyPrice = people.subsidyPrice
                    rel.appliedCoupons = people.appliedCoupons
                    rel.priceList = people.priceList
                  }
                  return rel
                })
              }
            })
            return room
          })
          return coupon
        })
        return night
      })
      return {
        stayNightDetails,
        totalDiscountAmount,
        totalAppliedCouponPrice,
        totalForceUseDiscount,
        remainingSubsidys,
        isChangeUsePlan
      }
    },

    $_couponMixin_checkEnabledChangeOptionalCouponCnt(bestChoiceResult, stayDay, peopleId, subsidyId, subsidyPriceId, multipleUnusableFlg) {
      let enabledChangeOptionalCouponCnt = true; // 初期値は選択可（選択不可の条件に該当しない）
      let bestChoicePeopleData = null;
      if (peopleId) {
        // 適用日と人物IDから該当該当するベストチョイスデータが無いか検索する
        bestChoicePeopleData = bestChoiceResult.find(data => stayDay == data.people.stayDay && peopleId == data.people.id)
      } else{
        // 一律の場合、人物を特定できないため利用している人物データを該当データとする
        const bestChoicePeopleArray = bestChoiceResult.filter(data => stayDay == data.people.stayDay);
        bestChoicePeopleData = bestChoicePeopleArray.find(data => {
          const appliedCouponsList = data.people.appliedCoupons;
          let i = 0; const len = appliedCouponsList.length;
          for (i; i < len; i++) {
            const coupon = appliedCouponsList[i];
            if (coupon.availableData.subsidyId == subsidyId) {
              return true;
            }
          }
          return false;
        });
      }

      // ベストチョイスデータがある場合、選択不可条件に当てはまらないかチェックする
      if (bestChoicePeopleData && bestChoicePeopleData.people && bestChoicePeopleData.people.appliedCoupons) {
        // 単価IDが一致している補助金データを取得する
        const appliedCoupons = bestChoicePeopleData.people.appliedCoupons
        const bestChoiceSubsidyData = appliedCoupons.find(data => {
          if (data.availableData.subsidyId == subsidyId) {
            const priceList = data.availableData.priceList;
            return priceList.find(price => price.subsidyPriceId == subsidyPriceId);
          }
          return false;
        });
        
        // 併用可/不可のチェック
        const couponIsAllowMultiple = multipleUnusableFlg != 1 ? true : false; // 枚数選択を制御するクーポンの併用可/不可
        // ベストチョイス時に併用可と不可どちらを採用したかと、枚数選択を制御するクーポンの併用可/不可を比較する（一致しない場合は、選択不可）
        // 併用不可の場合、枚数選択を制御するクーポンと単価IDが一致していないと選択不可
        if (couponIsAllowMultiple != bestChoicePeopleData.isMultiple ||
            !couponIsAllowMultiple && !bestChoiceSubsidyData
          ) {
          enabledChangeOptionalCouponCnt = false;
        }
      }
      return enabledChangeOptionalCouponCnt;
    }
  }
}
